<template lang="">
  <v-sheet style="width: 100%">
    <v-container class="pa-0" fluid> Coming Soon </v-container>
  </v-sheet>
</template>
<script setup>
// import { ref } from 'vue'
// import { findTopicList } from '@/apis/speaking'
// const tab = ref(1)

// const part1Topics = ref([])
// const fetchTopics = async() => {
//   var dataForm = {
//     testId: '1645350203594678273'
//   }
//   var res = await findTopicList(dataForm)
//   part1Topics.value = res.data.data
// }
// fetchTopics()
</script>
<style lang="scss">
ul.question_list {
  list-style: none;
  li {
    width: 100%;
  }
}
</style>
